import { render, staticRenderFns } from "./RewardsBankIdeas.vue?vue&type=template&id=37b4b49e&"
import script from "./RewardsBankIdeas.vue?vue&type=script&lang=js&"
export * from "./RewardsBankIdeas.vue?vue&type=script&lang=js&"
import style0 from "./RewardsBankIdeas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports